import DiscussionCompletionConditions from "./js/DiscussionCompletionConditions";
export default DiscussionCompletionConditions;